"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../shared"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

require("./SideNav.css");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function SideNavItem(_ref) {
  var Component = _ref.componentEl,
      children = _ref.children,
      className = _ref.className,
      active = _ref.active,
      disabled = _ref.disabled,
      icon = _ref.icon,
      wrap = _ref.wrap,
      color = _ref.color,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "children", "className", "active", "disabled", "icon", "wrap", "color"]);

  var cssClasses = ['st_sidenav__clickable', "st_sidenav__clickable--color-" + color];
  var clickableProps = {};
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  if (active) cssClasses.push('st_sidenav__clickable--active');
  if (wrap) cssClasses.push('st_sidenav__clickable--wrap');

  if (disabled) {
    cssClasses.push('st_sidenav__clickable--disabled');
    if (Component === 'button') clickableProps.disabled = true;
  }

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "st_sidenav__item"
  }, /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps, clickableProps), icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    margin: {
      right: 'sm'
    },
    type: icon,
    size: "md",
    className: "st_sidenav__icon"
  }), children));
}

SideNavItem.propTypes = {
  /** dom element or component to use for clickable element */
  componentEl: utils.componentEl.props,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** optional icon for token */
  icon: _propTypes["default"].string,

  /** whether item is active */
  active: _propTypes["default"].bool,

  /** whether item is disabled */
  disabled: _propTypes["default"].bool,

  /** color of item */
  color: _propTypes["default"].oneOf(['ink', 'blurple']),

  /** whether text should wrap if it overflows  */
  wrap: _propTypes["default"].bool
};
SideNavItem.defaultProps = {
  componentEl: 'a',
  className: null,
  icon: null,
  active: false,
  disabled: false,
  color: 'ink',
  wrap: false
};
SideNavItem.displayName = 'SideNav.Item';
var _default = SideNavItem;
exports["default"] = _default;